import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import Heading from 'src/elements/typography/heading';
import { BackgroundImage, BannerContainer, BannerContent, BannerHeadTitle, ContentText, MobileBackgroundImage } from './banner.engagementDrop.landing.styles';

interface BannerEngagementDropProps {
  title: string;
  subtitle: string;
  backgroundImage: IGatsbyImageData;
  mobileBackgroundImage: IGatsbyImageData;
}

const BannerEngagementDrop = ({ title, subtitle, backgroundImage, mobileBackgroundImage }: BannerEngagementDropProps): JSX.Element => {
  return (
    <BannerContainer>
      <BackgroundImage>
        <GatsbyImage image={backgroundImage} alt="background" />
      </BackgroundImage>
      <MobileBackgroundImage>
        <GatsbyImage image={mobileBackgroundImage} alt="mobile background" />
      </MobileBackgroundImage>
      <BannerContent>
        <ContentText>
          <BannerHeadTitle
            text={title}
            size="11.7rem"
            sizeXlg="8.4rem"
            sizeLg="7.2rem"
            sizeSubLg="4.5rem"
            sizeSm="4rem"
            sizeXs="3.1rem"
            lineHeight="180px"
            align="left"
            color="#ffffff"
          />
          <Heading
            text={subtitle}
            size="3.5rem"
            sizeXlg="3rem"
            sizeLg="2.7rem"
            sizeSubLg="2rem"
            sizeSm="1.6rem"
            align="left"
            color="#ffffff"
          />
        </ContentText>
      </BannerContent>
    </BannerContainer>
  )
}

export default BannerEngagementDrop;
